// extracted by mini-css-extract-plugin
export default {"price":"t1-z","onSale":"u1-z","msrpLabelPrice":"v1-z","originalPrice":"w1-z","msrpLabel":"x1-z","percentOff":"y1-z"};